export const blocGConstants = {
  GET_BLOCG_REQUEST: 'GET_BLOCG_REQUEST',
  GET_BLOCG_SUCCESS: 'GET_BLOCG_SUCCESS',
  GET_BLOCG_FAILURE: 'GET_BLOCG_FAILURE',

  UPDATE_BLOCG_REQUEST: 'UPDATE_BLOCG_REQUEST',
  UPDATE_BLOCG_SUCCESS: 'UPDATE_BLOCG_SUCCESS',
  UPDATE_BLOCG_FAILURE: 'UPDATE_BLOCG_FAILURE',
};
